import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject, map, tap } from 'rxjs';
import { User } from '@/app/core/user/user.types';
import { environment } from '@/environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private _baseUrl = environment.apiUrl;

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
    get(): Observable<User> {
        return this._httpClient.get<User>('api/common/user').pipe(
            tap((user) => {
                this._user.next(user);
            })
        );
    }

    /**
     * Update the user
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }

    getUser(): Observable<any> {
        return this._httpClient.get<any>(this._baseUrl + '/auth/me').pipe(
            map((response) => {
                console.log(response);
                this._user.next(response.data);
            })
        );
    }

    getUserProfile(): Observable<any> {
        return this._httpClient.get<any>(this._baseUrl + '/users/profile');
    }

    /**
     * Update the user
     * @param user
     */
    updateUser(user: any, role: string): Observable<any> {
        return this._httpClient
            .put(this._baseUrl + `/${role}`, user, {
                reportProgress: true,
                observe: 'events',
            })
            .pipe(
                map((event) => {
                    switch (event.type) {
                        case HttpEventType.UploadProgress:
                            return Math.round(
                                (event.loaded / (event.total || 1)) * 100
                            );
                        case HttpEventType.Response:
                            return 100;
                        default:
                            return 0;
                    }
                })
            );
    }
}
